import { call, put, takeEvery, select } from "redux-saga/effects"

// CONSTANTS
import {  CREATE_PAGE } from "./constants"

// ACTIONS
import { postNotificationAction } from "Containers/Notifications/actions"
import { getPagesSuccess, createNewPageSuccess } from "./actions"

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

// SELECTORS
import { selectCurrentToken, selectCurrentUser } from "Containers/Login/selectors.js"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

// Utils
import { getCors, postCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"




function* createNewPageSAGA({ payload }) {
  const { page, folder } = payload
  const token = yield select(selectCurrentToken)
  const currentUser = yield select(selectCurrentUser)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/v2/pages`

  try {
    const response = yield call(request, requestURL, postCors(page, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (response.pageCreatedId) {
        if (responseTypeIsSuccess(response)) {
          yield call(manageSuccessGenerator, { response, showMessageToUser: true })
          yield put(createNewPageSuccess(response.pageCreatedId))

        }
      }
    }
  } catch (err) {
    console.error("[route] => /pages => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* pageListSaga() {
  yield takeEvery(CREATE_PAGE, createNewPageSAGA)
}

export default pageListSaga
